import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from '@nuxtjs/composition-api';
import { getTimeSavedAndDownloadCount } from '~/utils/user';
import { User } from '~/types/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserTimeSaved',
  setup(__props) {

const store = useStore();
const loggedInUser = computed<User>(() => store.getters.loggedInUser);

const timeSaved = computed(() => getTimeSavedAndDownloadCount(loggedInUser.value));

return { __sfc: true,store, loggedInUser, timeSaved }
}

})